import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';

import DemandSwitches from '../store/DemandSwitches';


const styles = theme => ({
  paper: {
    padding: theme.spacing(2),
  },
});


@withStyles(styles)
@observer
class DemandSwitchesPanel extends React.Component {
  static propTypes = {
    switches: PropTypes.instanceOf(DemandSwitches).isRequired,
    direction: PropTypes.oneOf(['row', 'column']),
  };

  static defaultProps = {
    direction: 'row',
  };

  render() {
    const { switches, direction, classes } = this.props;
    if (switches.empty) {
      return <Skeleton variant="rect" height={direction === 'row' ? 70 : 150} />;
    }
    return (
      <Paper className={classes.paper}>
        <Grid container direction={direction} spacing={1} justify="space-around">
          {switches.entries().map(([label, value]) =>
            <Grid item key={label}>
              <FormControlLabel
                control={
                  <Switch
                    checked={value}
                    onChange={switches.onSwitchChange(label)}
                  />
                }
                label={label}
              />
            </Grid>
          )}
        </Grid>
      </Paper>
    );
  }
}


export default DemandSwitchesPanel;
